// import React, { useContext, useEffect,useState } from "react";
// import { AiFillCheckCircle } from "react-icons/ai";
// import { CgRadioCheck } from "react-icons/cg";
// import styled from "styled-components";
// import { UserStoryContext } from "../context/UserStoryState";
// import Modal from "./Modal";
// import OpCodeEditForm from "./OpCodeEditForm";
// import { LoaderSpinner } from "./LoaderSpinner";
// import { Dialog, DialogContent, DialogHeader, DialogTitle } from "src/components/ui/dialog";
// import { Badge } from "src/components/ui/badge";
// import { Card, CardContent } from "src/components/ui/card";
// import {
//     TableHead,
//     TableRow,
//     TableHeader,
//     TableCell,
//     TableBody,
//     Table,
// } from "./ui/table";
// import { Button } from "./ui/button";
// import { MdOutlineModeEdit } from "react-icons/md";
// import { Layout } from "lucide-react";

// const NoData = styled.div`
//     width: 100%;
//     font-size: 18px;
//     text-align: center;
//     margin: 20px 0;
//     font-weight: bolder;
//     padding: 20px;
// `;

// export default function OpCodeTableMultiple({
//     OpCodeEditTemplateName,
//     tableName,
//     tableCol,
//     tableData,
//     totalFetchedRow = 0,
//     tableDisplayOrder = "row",
//     haveSelect = false,
//     contextField = false,
//     data = false,
//     templateName = false,
//     isFetching,
//     allFrameData = false,
//     setAllFrameData = false,
//     details = false,
//     edit = false,
//     displayDetailsbtn = false
// }) {
//     const [selectedRecordIds, setSelectedRecordIds] = React.useState([]); // Store selected row IDs
//     const [showModal, setShowModal] = React.useState(false); // Control modal visibility
//     const [editRecordId, setEditRecordId] = React.useState(null); // Store the record ID to edit
//     const [ShowViewDetails, setShowViewDetails] = React.useState(null); // Control showing view details
//     const { AddContextData, contextData } = useContext(UserStoryContext); // Assuming contextData is part of UserStoryContext
//     const [contextvariable, setContextvariable] = useState(null);

//     useEffect(() => {
        
//                 setContextvariable(contextData)
                
//     }, [contextData]);

//     const handleRowClick = (userId) => {
//         const selectedRecord = tableData.tableRow.find((item) => item.recordId === userId);

//         if (selectedRecordIds.includes(userId)) {
//             // Remove from selection
//             const updatedSelectedRecordIds = selectedRecordIds.filter((id) => id !== userId);
//             setSelectedRecordIds(updatedSelectedRecordIds);

//             // Remove from context
//             removeContextData(userId);
//         } else {
//             // Add to selection
//             const updatedSelectedRecordIds = [...selectedRecordIds, userId];
//             setSelectedRecordIds(updatedSelectedRecordIds);

//             // Send the selected row's data to context
//             addContextData(selectedRecord);
//         }
//     };
// // Function to add selected data to context under the tableName key
// const addContextData = (selectedRow) => {
//     const contextFields = contextField;
//     let rowMergedData = {};

//     // Populate rowMergedData with the contextFields and selectedRow
//     for (const item of contextFields) {
//         if (selectedRow[item]) {
//             if (item === "recordId") {
//                 rowMergedData[tableName + "_recid"] = selectedRow[item];
//                 rowMergedData["cc" + tableName.charAt(0).toUpperCase() + tableName.slice(1)] = selectedRow[item];
//             } else {
//                 rowMergedData[item] = selectedRow[item];
//             }
//         }
//     }

//     // Find the object that contains the tableName key in the context, if it exists
//     const existingDataObject = contextvariable?.find(item => Object.keys(item).includes(tableName));

//     // Access the value for the tableName key (which should be an array or data)
//     const existingData = existingDataObject?.[tableName] || [];

//     console.log('existingData', existingData);

//     // Check if the row already exists in the context (based on the record ID)
//     const rowExists = existingData.some(row => row[tableName + "_recid"] === rowMergedData[tableName + "_recid"]);

//     // If the row does not already exist, append it to the array
//     if (!rowExists) {
//         const updatedData = [...existingData, rowMergedData];

//         // Update context with the new array that includes the newly selected row
//         AddContextData({
//             [tableName]: updatedData // Only update the specific table data
//         });

//         console.log('Updated context data:', updatedData);
//     }
// };


// const removeContextData = (recordId) => {
//     // Find the object that contains the tableName key in the context, if it exists
//     const existingDataObject = contextvariable?.find(item => Object.keys(item).includes(tableName));

//     // Access the value for the tableName key (which should be an array or data)
//     const existingData = existingDataObject?.[tableName] || [];

//     // Filter out the row to remove, based on the recordId
//     const updatedData = existingData.filter(
//         (row) => row[tableName + "_recid"] !== recordId
//     );

//     // Update context with the new array that excludes the deselected row
//     AddContextData({
//         [tableName]: updatedData // Only update the specific table data
//     });

//     console.log('Updated context data after removal:', updatedData);
// };




//     useEffect(() => {
//         if (showModal) {
//             document.body.style.overflow = 'hidden';
//         } else {
//             document.body.style.overflow = 'auto';
//         }

//         return () => {
//             document.body.style.overflow = 'auto';
//         };
//     }, [showModal]);

//     const handleViewDetailsClick = (item) => {
//         setShowViewDetails(item); // Set selected record to display in dialog
//     };

//     return (
//         <div className="overflow-auto">
//             <Table>
//                 {isFetching === false ? (
//                     tableCol && totalFetchedRow > 0 ? (
//                         <>
//                             <TableHeader className="bg-[#F3F4F6] font-bold">
//                                 <TableRow>
//                                     {tableCol && (
//                                         <>
//                                             {haveSelect && <TableHead className="w-[32px] py-10"></TableHead>}
//                                             {tableCol.map((item, index) =>
//                                                 item.visible !== false && (
//                                                     <TableHead
//                                                         className="text-[#0B236B]"
//                                                         key={index}
//                                                         style={{
//                                                             width: item.size,
//                                                             maxWidth: item.size,
//                                                         }}
//                                                     >
//                                                         {item.title}
//                                                     </TableHead>
//                                                 )
//                                             )}
//                                             <TableHead></TableHead>
//                                         </>
//                                     )}
//                                 </TableRow>
//                             </TableHeader>
//                             <TableBody>
//                                 {tableDisplayOrder === "row" &&
//                                     tableData &&
//                                     tableData.tableRow &&
//                                     tableData.tableRow.length > 0 &&
//                                     tableData.tableRow.map((item, itemIndex) => (
//                                         <TableRow key={itemIndex}>
//                                             {haveSelect && (
//                                                 <TableCell
//                                                     style={{
//                                                         width: "30px",
//                                                         textAlign: "center",
//                                                     }}
//                                                 >
//                                                     <div onClick={() => handleRowClick(item.recordId)} className="toggle-button">
//                                                         {selectedRecordIds.includes(item.recordId) ? (
//                                                             <AiFillCheckCircle
//                                                                 style={{
//                                                                     color: "#bb0000",
//                                                                     fontSize: "23px",
//                                                                 }}
//                                                             />
//                                                         ) : (
//                                                             <CgRadioCheck
//                                                                 style={{
//                                                                     fontSize: "23px",
//                                                                 }}
//                                                             />
//                                                         )}
//                                                     </div>
//                                                 </TableCell>
//                                             )}
//                                             {tableCol.map(
//                                                 (tableItem, index) =>
//                                                     tableItem.visible !== false && (
//                                                         <TableCell
//                                                             key={index}
//                                                             style={{
//                                                                 width: tableItem.size,
//                                                                 maxWidth: tableItem.size,
//                                                             }}
//                                                         >
//                                                             {item[tableItem.field]}
//                                                         </TableCell>
//                                                     )
//                                             )}
//                                             <TableCell
//                                                 style={{
//                                                     width: "50px",
//                                                     textAlign: "center",
//                                                 }}
//                                             >
//                                                 {edit && (
//                                                     <Button
//                                                         onClick={() => {
//                                                             setShowModal(true); // Open the modal
//                                                             setEditRecordId(item.recordId); // Set the ID of the record to edit
//                                                         }}
//                                                     >
//                                                         Edit
//                                                         <MdOutlineModeEdit className="ml-2 mr-0 h-4 w-4" />
//                                                     </Button>
//                                                 )}
//                                                 {displayDetailsbtn && (
//                                                     <Button
//                                                         onClick={() => handleViewDetailsClick(item)}
//                                                         style={{ marginLeft: "10px" }}
//                                                         variant="secondary"
//                                                     >
//                                                         View Details
//                                                     </Button>
//                                                 )}
//                                             </TableCell>
//                                         </TableRow>
//                                     ))}
//                             </TableBody>

//                             {/* Modal for Editing */}
//                             {tableData && showModal && (
//                                 <Modal $isOpen={showModal} setOpenModal={setShowModal}>
//                                     <Modal.Header>OP Code Edit Form</Modal.Header>
//                                     <Modal.Body>
//                                         <OpCodeEditForm
//                                             recordId={editRecordId}
//                                             templateName={OpCodeEditTemplateName}
//                                             tableName={tableName}
//                                         />
//                                     </Modal.Body>
//                                 </Modal>
//                             )}

//                             {/* Dialog for View Details */}
//                             {ShowViewDetails && (
//                                 <Dialog open={!!ShowViewDetails} onOpenChange={() => setShowViewDetails(null)}>
//                                     <DialogContent className="max-w-4xl max-h-[80vh] overflow-y-auto">
//                                         <DialogHeader className="relative">
//                                             <DialogTitle className="text-3xl font-bold mb-4">{details.Title}</DialogTitle>
//                                         </DialogHeader>
//                                         <div className="grid grid-cols-1 md:grid-cols-2 gap-6 p-4">
//                                             {details.fields.map((field, index) => (
//                                                 <Card
//                                                     key={index}
//                                                     className={field.type === "fullCard" ? "col-span-1 md:col-span-2" : "col-span-1"}
//                                                     style={{ background: field.background }}
//                                                 >
//                                                     <CardContent className="pt-6">
//                                                         <div className="flex items-center space-x-2 mb-4">
//                                                             <Layout className="h-5 w-5 text-blue-500" />
//                                                             <h3 className="text-lg font-semibold">{field.title}</h3>
//                                                         </div>
//                                                         {field.badges && (
//                                                             <div className="flex space-x-2 mb-4">
//                                                                 {field.badges.map((badge, badgeIndex) => (
//                                                                     <Badge key={badgeIndex} variant={badge.variant}>
//                                                                         {badge.title}
//                                                                     </Badge>
//                                                                 ))}
//                                                             </div>
//                                                         )}
//                                                         {field.data && (
//                                                             <div className={`grid grid-cols-${field.dataDispay === "sidebyside" ? "2" : "1"} gap-4`}>
//                                                                 {field.data.map((dataItem, dataIndex) => (
//                                                                     <p key={dataIndex}>
//                                                                         <span className="font-medium">{dataItem.title}: </span>
//                                                                         {ShowViewDetails[dataItem.field] || "N/A"}
//                                                                     </p>
//                                                                 ))}
//                                                             </div>
//                                                         )}
//                                                         {field.billing && (
//                                                             <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
//                                                                 {field.billing.map((billingItem, billingIndex) => (
//                                                                     <div
//                                                                         key={billingIndex}
//                                                                         className="p-4 rounded-md"
//                                                                         style={{ backgroundColor: billingItem.color || "inherit" }}
//                                                                     >
//                                                                         <p className="font-medium">{billingItem.title}</p>
//                                                                         <p className="text-2xl font-bold">
//                                                                             {ShowViewDetails[billingItem.field] ? `$${ShowViewDetails[billingItem.field]}` : "N/A"}
//                                                                         </p>
//                                                                     </div>
//                                                                 ))}
//                                                             </div>
//                                                         )}
//                                                     </CardContent>
//                                                 </Card>
//                                             ))}
//                                         </div>
//                                     </DialogContent>
//                                 </Dialog>
//                             )}
//                         </>
//                     ) : (
//                         <NoData>No data found!</NoData>
//                     )
//                 ) : (
//                     <NoData>
//                         <LoaderSpinner />
//                     </NoData>
//                 )}
//             </Table>
//         </div>
//     );
// }





import React, { useContext, useEffect, useState } from "react";
import { AiFillCheckCircle } from "react-icons/ai";
import { CgRadioCheck } from "react-icons/cg";
import styled from "styled-components";
import { UserStoryContext } from "../context/UserStoryState";
import Modal from "./Modal";
import OpCodeEditForm from "./OpCodeEditForm";
import { LoaderSpinner } from "./LoaderSpinner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "src/components/ui/dialog";
import { Badge } from "src/components/ui/badge";
import { Card, CardContent } from "src/components/ui/card";
import { TableHead, TableRow, TableHeader, TableCell, TableBody, Table } from "./ui/table";
import { Button } from "./ui/button";
import { MdOutlineModeEdit } from "react-icons/md";
import { Layout } from "lucide-react";

const NoData = styled.div`
  width: 100%;
  font-size: 18px;
  text-align: center;
  margin: 20px 0;
  font-weight: bolder;
  padding: 20px;
`;

export default function OpCodeTableMultiple({
  OpCodeEditTemplateName,
  tableName,
  tableCol,
  tableData,
  totalFetchedRow = 0,
  tableDisplayOrder = "row",
  haveSelect = false,
  contextField = false,
  data = false,
  templateName = false,
  isFetching,
  allFrameData = false,
  setAllFrameData = false,
  details = false,
  edit = false,
  displayDetailsbtn = false,
}) {
  const [selectedRecordIds, setSelectedRecordIds] = useState([]); // Store selected row IDs
  const [showModal, setShowModal] = useState(false); // Control modal visibility
  const [editRecordId, setEditRecordId] = useState(null); // Store the record ID to edit
  const [ShowViewDetails, setShowViewDetails] = useState(null); // Control showing view details
  const { AddContextData, contextData } = useContext(UserStoryContext); // Assuming contextData is part of UserStoryContext
  const [contextvariable, setContextvariable] = useState(null);
  const [selectAll, setSelectAll] = useState(false); // Track if all rows are selected

  useEffect(() => {
    setContextvariable(contextData);
  }, [contextData]);

  // Function to handle select/deselect individual rows
  const handleRowClick = (userId) => {
    const selectedRecord = tableData.tableRow.find((item) => item.recordId === userId);

    if (selectedRecordIds.includes(userId)) {
      // Remove from selection
      const updatedSelectedRecordIds = selectedRecordIds.filter((id) => id !== userId);
      setSelectedRecordIds(updatedSelectedRecordIds);

      // Remove from context
      removeContextData(userId);
    } else {
      // Add to selection
      const updatedSelectedRecordIds = [...selectedRecordIds, userId];
      setSelectedRecordIds(updatedSelectedRecordIds);

      // Send the selected row's data to context
      addContextData(selectedRecord);
    }
  };
  const handleViewDetailsClick = (item) => {
    setShowViewDetails(item); // Set selected record to display in dialog
};

  // Function to add selected data to context under the tableName key
  const addContextData = (selectedRow) => {
    const contextFields = contextField;
    let rowMergedData = {};

    // Populate rowMergedData with the contextFields and selectedRow
    for (const item of contextFields) {
      if (selectedRow[item]) {
        if (item === "recordId") {
          rowMergedData[tableName + "_recid"] = selectedRow[item];
          rowMergedData["cc" + tableName.charAt(0).toUpperCase() + tableName.slice(1)] = selectedRow[item];
        } else {
          rowMergedData[item] = selectedRow[item];
        }
      }
    }

    // Find the object that contains the tableName key in the context, if it exists
    const existingDataObject = contextvariable?.find((item) => Object.keys(item).includes(tableName));

    // Access the value for the tableName key (which should be an array or data)
    const existingData = existingDataObject?.[tableName] || [];

    // Check if the row already exists in the context (based on the record ID)
    const rowExists = existingData.some((row) => row[tableName + "_recid"] === rowMergedData[tableName + "_recid"]);

    // If the row does not already exist, append it to the array
    if (!rowExists) {
      const updatedData = [...existingData, rowMergedData];

      // Update context with the new array that includes the newly selected row
      AddContextData({
        [tableName]: updatedData, // Only update the specific table data
      });
    }
  };

  const removeContextData = (recordId) => {
    // Find the object that contains the tableName key in the context, if it exists
    const existingDataObject = contextvariable?.find((item) => Object.keys(item).includes(tableName));

    // Access the value for the tableName key (which should be an array or data)
    const existingData = existingDataObject?.[tableName] || [];

    // Filter out the row to remove, based on the recordId
    const updatedData = existingData.filter((row) => row[tableName + "_recid"] !== recordId);

    // Update context with the new array that excludes the deselected row
    AddContextData({
      [tableName]: updatedData, // Only update the specific table data
    });
  };

  // Handle Select All / Deselect All
  const handleSelectAll = () => {
    if (selectAll) {
      // Deselect all rows
      setSelectedRecordIds([]);
      tableData.tableRow.forEach((item) => removeContextData(item.recordId));
    } else {
      // Select all rows
      const allIds = tableData.tableRow.map((item) => item.recordId);
      setSelectedRecordIds(allIds);
      tableData.tableRow.forEach((item) => addContextData(item));
    }
    setSelectAll(!selectAll); // Toggle the select all state
  };

  return (
    <div className="overflow-auto">
      <Table>
        {isFetching === false ? (
          tableCol && totalFetchedRow > 0 ? (
            <>
              <TableHeader className="bg-[#F3F4F6] font-bold">
                <TableRow>
                  {haveSelect && (
                    <TableHead className="w-[32px] py-10">
                      <Button onClick={handleSelectAll}>{selectAll ? "Deselect All" : "Select All"}</Button>
                    </TableHead>
                  )}
                  {tableCol.map(
                    (item, index) =>
                      item.visible !== false && (
                        <TableHead
                          className="text-[#0B236B]"
                          key={index}
                          style={{
                            width: item.size,
                            maxWidth: item.size,
                          }}
                        >
                          {item.title}
                        </TableHead>
                      )
                  )}
                  <TableHead></TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {tableDisplayOrder === "row" &&
                  tableData &&
                  tableData.tableRow &&
                  tableData.tableRow.length > 0 &&
                  tableData.tableRow.map((item, itemIndex) => (
                    <TableRow key={itemIndex}>
                      {haveSelect && (
                        <TableCell
                          style={{
                            width: "30px",
                            textAlign: "center",
                          }}
                        >
                          <div onClick={() => handleRowClick(item.recordId)} className="toggle-button">
                            {selectedRecordIds.includes(item.recordId) ? (
                              <AiFillCheckCircle
                                style={{
                                  color: "#bb0000",
                                  fontSize: "23px",
                                }}
                              />
                            ) : (
                              <CgRadioCheck
                                style={{
                                  fontSize: "23px",
                                }}
                              />
                            )}
                          </div>
                        </TableCell>
                      )}
                      {tableCol.map(
                        (tableItem, index) =>
                          tableItem.visible !== false && (
                            <TableCell
                              key={index}
                              style={{
                                width: tableItem.size,
                                maxWidth: tableItem.size,
                              }}
                            >
                              {item[tableItem.field]}
                            </TableCell>
                          )
                      )}
                      <TableCell
                        style={{
                          width: "50px",
                          textAlign: "center",
                        }}
                      >
                        {edit && (
                          <Button
                            onClick={() => {
                              setShowModal(true); // Open the modal
                              setEditRecordId(item.recordId); // Set the ID of the record to edit
                            }}
                          >
                            Edit
                            <MdOutlineModeEdit className="ml-2 mr-0 h-4 w-4" />
                          </Button>
                        )}
                        {displayDetailsbtn && (
                          <Button
                            onClick={() => handleViewDetailsClick(item)}
                            style={{ marginLeft: "10px" }}
                            variant="secondary"
                          >
                            View Details
                          </Button>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </>
          ) : (
            <NoData>No data found!</NoData>
          )
        ) : (
          <NoData>
            <LoaderSpinner />
          </NoData>
        )}
      </Table>
    </div>
  );
}
